import FinsightChart from './FinsightChart';

export default FinsightChart;
